// extracted by mini-css-extract-plugin
export default {"title":"viewAdmin_title__Vp34z","content":"viewAdmin_content__w4Ao8","row":"viewAdmin_row__jL4bC"};